import Credit from "./checkout/credit";
import Gateways from "./checkout/gateways";
import Trasnfer from "./checkout/transfer";
import PaymentLink from "./order/payment-link";
import Thankyou from "./order/thankyou";
import VindiOneClickBuy from "./order/one-click-buy";
import VindiMultipayment from "./checkout/vindi-multipayment";


window.vindiMultiPaymentSettings = window.vindiMultiPaymentSettings || {
    ajaxUrl: typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp-admin/admin-ajax.php',
    totalAmount: '0.00',
    currency: 'BRL',
    currencySymbol: 'R$'
};

(function ($) {
  $(document).on("ready updated_checkout", () => {
    new Thankyou();
    new Credit();
    new Trasnfer();
    new Gateways();
    new PaymentLink();
    new VindiOneClickBuy();
    new VindiMultipayment();
  });

  $(document).on("add_checkout_block_fields", () => {
    new Trasnfer();
    new Gateways();
  });

})(jQuery);
